import type { ReactNode } from 'react';
/** Collapsed "Developer tools" block holding a step's debugging aids. */
export default function RagDevTools({ children }: { children: ReactNode }) {
  return (
    <details className="mt-[18px] rounded-[12px] border border-line bg-surface-2 px-3.5 py-2.5 text-xs text-muted">
      <summary className="cursor-pointer font-mono text-[11px] font-semibold uppercase tracking-[0.08em]">Developer tools</summary>
      <div className="mt-2.5 space-y-2.5">{children}</div>
    </details>
  );
}
